import { Typography, Link } from '@one-thd/sui-atomic-components';
import { Store, QRCode, BuyAgain } from '@one-thd/sui-icons';
import React, { useEffect } from 'react';
import { goToPreviousStep } from '../../stores/flowStore';
import { ReturnButtons } from '../shared/ReturnButtons';
import { disableAbandonmentSurvey } from '../../utils/storage-helper';
import { useReturnStore } from '../../stores/returnStore';
import { redirectToOrderDetails } from '../../utils/general';
import OrderNumberBarcode from './OrderNumberBarcode';
export var Phase0InStoreReturnMethod = function () {
    var isMilitaryExchangeGuest = useReturnStore(function (state) { return state.isMilitaryExchangeGuest; });
    var orderDetailsPath = useReturnStore(function (state) { return state.orderDetailsPath; });
    useEffect(function () {
        disableAbandonmentSurvey(); // Safety net to make sure survey is disabled
    }, []);
    return (React.createElement("div", { className: "sui-max-w-xl", "data-testid": "phase0-instore" },
        React.createElement("div", { className: "sui-mb-4" },
            React.createElement(Typography, { weight: "bold" }, "In-Store Drop-Off Instructions")),
        React.createElement(OrderNumberBarcode, null),
        React.createElement("div", { className: "sui-mb-4 sui-flex sui-gap-3" },
            React.createElement("div", { className: "sui-pt-[6px]" },
                React.createElement(Store, null)),
            React.createElement(Typography, null,
                "Take your return items to any",
                ' ',
                React.createElement(Link, { href: "https://www.homedepot.com/l/", target: "_blank" }, "Home Depot store."))),
        React.createElement("div", { className: "sui-mb-4 sui-flex sui-gap-3" },
            React.createElement("div", { className: "sui-pt-[6px]" },
                React.createElement(QRCode, null)),
            React.createElement(Typography, null,
                "Show your barcode",
                !isMilitaryExchangeGuest && (React.createElement(React.Fragment, null, ", receipt or the card used at purchase")),
                ' ',
                "to an associate at the returns counter.")),
        React.createElement("div", { className: "sui-flex sui-gap-3" },
            React.createElement("div", { className: "sui-pt-[6px]" },
                React.createElement(BuyAgain, null)),
            React.createElement(Typography, null, "It may take up to 10 business days for your bank to put the funds back into your account.")),
        React.createElement(ReturnButtons, { proceedNext: function () {
                return redirectToOrderDetails(orderDetailsPath, isMilitaryExchangeGuest);
            }, proceedBack: function () {
                goToPreviousStep('ReturnMethod');
            }, instore: true })));
};
